const captchaDisabledEnv = process.env.CAPTCHA_DISABLED;
const captchaDisabled =
    captchaDisabledEnv === '1' ||
    String(captchaDisabledEnv ?? '').toLowerCase() === 'true';
/** Значения домена приходят рантаймом из www/t/_partial/app_config.twig:
 *  один бандл обслуживает и основной домен, и резервное зеркало.
 *  process.env — fallback для локальной разработки и сборки без шаблона. */
const runtime = (typeof window !== 'undefined' && window.__APP_CONFIG__) || {};
const rootUrl = String(runtime.ROOT_URL || process.env.ROOT_URL || '').toLowerCase();
const apiUrl = String(runtime.API_URL || process.env.API_URL || '').toLowerCase();

let config = {
    ROOT_URL: rootUrl,
    API_URL: apiUrl,
    PUBLIC_DOMAIN_COOKIES: runtime.PUBLIC_DOMAIN_COOKIES || process.env.PUBLIC_DOMAIN_COOKIES,
    DADATA_API_KEY: process.env.DADATA_API_KEY,
    DOC_API_URL: process.env.DOC_API_URL,
    CAPTACHA_V2_KEY: process.env.CAPTACHA_V2_KEY,
    /** Синхронно с api/Middleware/Captcha.php: не грузить виджет и не требовать токен */
    CAPTCHA_DISABLED: captchaDisabled,
    FIREBASE_API_KEY: process.env.FIREBASE_API_KEY,
    FIREBASE_AUTH_DOMAIN: process.env.FIREBASE_AUTH_DOMAIN,
    FIREBASE_PROJECT_ID: process.env.FIREBASE_PROJECT_ID,
    FIREBASE_STORAGE_BUCKET: process.env.FIREBASE_STORAGE_BUCKET,
    FIREBASE_MESSAGING_SENDER_ID: process.env.FIREBASE_MESSAGING_SENDER_ID,
    FIREBASE_APP_ID: process.env.FIREBASE_APP_ID,
    FIREBASE_VAPID_KEY: process.env.FIREBASE_VAPID_KEY,
};
export default config;
